module.exports = "/assets/7795279317239199b1cc6bccb271971d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/OX.png
// module id = 2820
// module chunks = 0